import React from 'react'

function Custom_Loader() {
  return (
    <div className='cl'>
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      </div> 
  )
}

export default Custom_Loader